import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import { buttons as Buttons } from '@breezeway/brzw-components';

import './button_link_dropdown.scss';

const { LINK_SECOND_LIGHT, LINK_SECOND_DARK } = Buttons.constants.BUTTON_THEMES;

class ButtonLinkDropdown extends Component {
  static getDerivedStateFromProps(props, state) {
    const { isOpen } = props;
    const { isOpen: isOpenState } = state;

    return isOpen !== isOpenState ? { isOpen } : null;
  }

  constructor(props) {
    super(props);
    const { isOpen } = props;

    this.state = { isOpen };
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown() {
    const { name, onClick } = this.props;

    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }), () => {
      if (name && _.isFunction(onClick)) {
        onClick(name);
      }
    });
  }

  renderOptions() {
    const { options, parentText, darkTheme } = this.props;

    return _.map(options, (option, index) => {
      const key = `${_.kebabCase(parentText)}_${index}`;
      return (
        <Buttons.IconTextButton
          {...option}
          key={key}
          onClick={option.onClick}
          theme={darkTheme ? LINK_SECOND_DARK : LINK_SECOND_LIGHT}
          asChild
        >
          {option.text}
        </Buttons.IconTextButton>
      );
    });
  }

  render() {
    const {
      darkTheme,
      parentText,
      className,
      options,
      activeIconNameRight,
      iconNameRight,
    } = this.props;
    const { isOpen } = this.state;

    const restProps = _.omit(this.props, [
      'activeIconNameRight',
      'darkTheme',
      'isOpen',
      'parentText',
    ]);

    return (
      <div className={classnames('button-link-dropdown', className)}>
        <Buttons.IconTextButton
          {...restProps}
          onClick={this.toggleDropdown}
          theme={darkTheme ? LINK_SECOND_DARK : LINK_SECOND_LIGHT}
          iconNameRight={
            !_.isEmpty(activeIconNameRight) && isOpen ? activeIconNameRight : iconNameRight
          }
        >
          {parentText}
        </Buttons.IconTextButton>
        {!_.isEmpty(options) && (
          <div className={classnames('button-link-dropdown__options', { '-is-open': isOpen })}>
            {this.renderOptions()}
          </div>
        )}
      </div>
    );
  }
}

ButtonLinkDropdown.propTypes = {
  activeIconNameRight: PropTypes.string,
  className: PropTypes.string,
  darkTheme: PropTypes.bool,
  iconNameRight: PropTypes.string,
  isOpen: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape),
  parentText: PropTypes.string,
};

ButtonLinkDropdown.defaultTypes = {
  activeIconNameRight: null,
  className: '',
  darkTheme: false,
  iconNameRight: null,
  isOpen: false,
  onClick: null,
  options: [],
  parentText: '',
};

export default ButtonLinkDropdown;
